export default __webpack_public_path__ + "static/media/Edit.4ab3c5af.svg";